import React from 'react';
import { TechnicalSheetData } from './types';
import { PropertySheetHeader } from './PropertySheetHeader';
import { PropertySheetGallery } from './PropertySheetGallery';
import { PropertyKeyMetricsStrip } from './PropertyKeyMetricsStrip';
import { PropertyDescriptionCard } from './PropertyDescriptionCard';
import { PropertyLocationMapPreview } from './PropertyLocationMapPreview';
import { PropertySpecsTable } from './PropertySpecsTable';
import { PropertyAgentContactCard } from './PropertyAgentContactCard';
import { PropertySheetFooter } from './PropertySheetFooter';

interface PropertyTechnicalSheetDocumentProps {
  data: TechnicalSheetData;
  id?: string;
  className?: string;
}

export const PropertyTechnicalSheetDocument: React.FC<PropertyTechnicalSheetDocumentProps> = ({
  data,
  id = 'bolivar-technical-sheet',
  className = '',
}) => {
  return (
    <article
      id={id}
      style={{ width: '800px', minWidth: '800px', maxWidth: '800px' }}
      className={`bg-[#ffffff] text-[#1e293b] p-6 rounded-2xl shadow-xl border border-[#e2e8f0] font-sans box-border select-none print:shadow-none print:border-none print:p-5 print:rounded-none ${className}`}
    >
      {/* 1. Header with operation pill, brand/broker info, title and code */}
      <PropertySheetHeader
        operationType={data.operationType}
        propertyType={data.propertyType}
        title={data.title}
        address={data.address}
        referenceCode={data.referenceCode}
        branding={data.branding}
      />

      {/* 2. Bento Gallery (Mosaico 2x2 para 4 imágenes o tríptico para 3) */}
      <PropertySheetGallery images={data.images} badgeText={data.mainBadge} />

      {/* 3. Key Metrics Horizontal Strip (Area, Rooms, Baths, Garages) */}
      <PropertyKeyMetricsStrip
        area={data.metrics.area}
        rooms={data.metrics.rooms}
        baths={data.metrics.baths}
        parking={data.metrics.parking}
      />

      {/* 4. Two-Column Layout (idéntico en PC y móvil por diseño a escala) */}
      <div className="grid grid-cols-12 gap-3 items-start">
        {/* Left Column (7 cols): Description + Real OpenStreetMap Location */}
        <div className="col-span-7 space-y-3">
          <PropertyDescriptionCard description={data.description} />
          <PropertyLocationMapPreview location={data.location} />
        </div>

        {/* Right Column (5 cols): Technical Specs + Broker Contact Details */}
        <div className="col-span-5 space-y-3">
          <PropertySpecsTable specs={data.specs} />
          {data.showAdvisorSection !== false && (
            <PropertyAgentContactCard
              advisor={data.advisor}
              showContactInfo={data.showAdvisorContactInfo}
            />
          )}
        </div>
      </div>

      {/* 5. Footer & Legal Disclaimer */}
      <PropertySheetFooter
        propertyCode={data.footerCode}
        footerBrandText={data.branding.footerBrandText}
        pageNumber={data.pageNumber}
        totalPages={data.totalPages}
      />
    </article>
  );
};
